<script setup lang="ts">
import LoginButton from './common/LoginButton.vue'
import Header from './ui/Header.vue'
import ProfileDropdown from './ui/ProfileDropdown.vue'

const nuxtApp = useNuxtApp()
const links = computed(() => [
  {
    label: 'Home',
    to: '/',
    icon: 'i-heroicons-cube-transparent',
    active: nuxtApp.$router.currentRoute.value.path === '/'
  },
  {
    label: 'BPSDM Pertahanan',
    to: '/bpsdm-pertahanan',
    icon: 'i-heroicons-shield-check',
    active: nuxtApp.$router.currentRoute.value.path === '/bpsdm-pertahanan'
  },
  {
    label: 'Personel',
    to: '/personel',
    icon: 'carbon:user-military',
    active: nuxtApp.$router.currentRoute.value.path === '/personel'
  },
  {
    label: 'Pusdiklat',
    to: '/pusdiklat',
    icon: 'i-heroicons-academic-cap',
    active: nuxtApp.$router.currentRoute.value.path.startsWith('/pusdiklat'),
    children: [
      {
        label: 'Pusdiklat Jemenhan',
        to: '/pusdiklat/jemenhan',
        icon: 'i-heroicons-clipboard-document-list',
        image: '/assets/logo-subbadan-jemenhan.png',
        description: 'Pusdiklat Manajemen Pertahanan.'
      },
      {
        label: 'Pusdiklat Bahasa',
        to: '/pusdiklat/bahasa',
        icon: 'i-heroicons-book-open',
        image: '/assets/logo-subbadan-bahasa.png',
        description: 'Pusat Pendidikan dan Pelatihan Bahasa.'
      },
      {
        label: 'Pusdiklat Tekfunghan',
        to: '/pusdiklat/tekfunghan',
        icon: 'i-heroicons-briefcase',
        image: '/assets/logo-subbadan-tekfunghan.png',
        description: 'Pusdiklat Teknis Fungsional Pertahanan.'
      },
      {
        label: 'Pusdiklat Bela Negara',
        to: '/pusdiklat/bela-negara',
        icon: 'i-heroicons-shield-check',
        image: '/assets/logo-subbadan-belanegara.png',
        description: 'Pusat Pendidikan dan Pelatihan Bela Negara.'
      }
    ]
  },
  {
    label: 'Diklat',
    to: '/diklat',
    icon: 'i-heroicons-book-open',
    active: nuxtApp.$router.currentRoute.value.path === '/diklat',
    children: [
      { label: 'Daftar Diklat', to: '/diklat' },
      { label: 'Jadwal Diklat', to: '/jadwal-diklat' },
      { label: 'Riwayat Materi', to: '/history-materi' },
      { label: 'E-Katalog', to: '/e-katalog' }
    ]
  },
  {
    label: 'Berita',
    to: '/berita',
    icon: 'i-heroicons-newspaper',
    active: nuxtApp.$router.currentRoute.value.path === '/berita'
  },
  {
    label: 'Kontak',
    to: '/kontak',
    icon: 'heroicons:chat-bubble-oval-left-ellipsis',
    active: nuxtApp.$router.currentRoute.value.path === '/kontak'
  }
])
</script>

<template>
  <Header :links="links">
    <template #logo>
      <NuxtImg
        src="/assets/logo-oneklik-bpsdm.png"
        alt="logo-oneklik-bpsdm"
        class="max-h-10"
      />
    </template>

    <template #right>
      <UTooltip
        text="Pencarian"
        :shortcuts="['Ctrl', 'K']"
      >
        <UButton
          icon="heroicons-magnifying-glass"
          color="gray"
          variant="ghost"
          @click="useUIState().toggleContentSearch"
        />
      </UTooltip>

      <ClientOnly>
        <ProfileDropdown />

        <template #fallback>
          <UIcon
            name="eos-icons:bubble-loading"
            class="mx-2 text-3xl text-orange-600 dark:text-orange-400"
          />
        </template>
      </ClientOnly>
    </template>

    <template #panel>
      <UAsideLinks :links="links" />

      <UDivider class="my-6" />
      <ClientOnly>
        <LoginButton />
      </ClientOnly>
    </template>
  </Header>
</template>
